module.exports = "<div class=\"btn-group-vertical fixed-right\" role=\"group\" aria-label=\"Vertical button group\">\n\t<div *ngIf=\"!adminEdicion()\">\n\t\t<div *ngFor=\"let button of lenguage\">\n\t\t\t<a class=\"btn btn-primary ml-0 white-text\" (click)=\"changeLenguage(button.cod)\" >{{button.nombre}}</a>\n\t\t</div>\n\t</div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/buttons-lenguage/buttons-lenguage.component.html
// module id = ./src/app/shared/components/buttons-lenguage/buttons-lenguage.component.html
// module chunks = main